// A stored slides history label ("added 2 elements, grouped") cut into i18n keys. Kept apart from
// history.ts, which pulls in the slides model: the History modal (main chunk) names a slides entry's
// changes with this, and must not drag the lazily loaded editor in with it.

/** One piece of a stored label: an i18n key (with its count), or text kept as written. */
export type LabelPart = { key: string; n: number; text?: undefined } | { key?: undefined; text: string }

const LABEL_WORDS: Array<[RegExp, string]> = [
  [/^added the slide$/, 'sl_h_added_slide'],
  [/^deleted the slide$/, 'sl_h_deleted_slide'],
  [/^moved the slide$/, 'sl_h_moved_slide'],
  [/^changed the slide$/, 'sl_h_changed_slide'],
  [/^added (\d+) elements?$/, 'sl_h_added'],
  [/^changed (\d+) elements?$/, 'sl_h_changed'],
  [/^deleted (\d+) elements?$/, 'sl_h_deleted'],
  [/^moved (\d+) elements?$/, 'sl_h_moved'],
  [/^grouped(?: (\d+) times)?$/, 'sl_h_grouped'],
  [/^ungrouped(?: (\d+) times)?$/, 'sl_h_ungrouped'],
  [/^regrouped(?: (\d+) times)?$/, 'sl_h_regrouped'],
]

/**
 * A stored label ("added 2 elements, grouped": the server's English words, and this module's) cut
 * into pieces the UI can say in the member's language. A count of 1 picks the `_1` key. Words this
 * client does not know (a newer server) are kept as written.
 */
export function labelParts(label: string): LabelPart[] {
  return label.split(', ').map((text): LabelPart => {
    for (const [re, key] of LABEL_WORDS) {
      const m = re.exec(text)
      if (!m) continue
      const n = m[1] ? Number(m[1]) : 1
      const counted = re.source.includes('(\\d+)')
      return { key: counted && n === 1 ? `${key}_1` : key, n }
    }
    return { text }
  })
}
